import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import HmiCard from './HmiCard';
import FormatMessage from '../../messages/FormatMessage';

const HmiPurposeAndDurationOfDataUsage: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }

  const { info } = parentApp;

  return (
    <HmiCard titleMessageId={'hmi.dataDebit.purposeOfDataUsage'}>
      <div className={'hmi-card-content'}>
        <div className={'hmi-card-subtitle'}>{info.dataUsePurpose}</div>
        <div
          className={'hmi-card-title'}
          style={{ marginTop: '1rem', marginBottom: '0' }}
        >
          <FormatMessage id={'hmi.dataUsage.forTheDurationOf'} />
        </div>
        <ul className={'instruction-list'}>
          <li className={'list-item'}>
            <FormatMessage id={'hmi.dataUsage.untilDisabled'} />
          </li>
        </ul>
      </div>
    </HmiCard>
  );
};

export default HmiPurposeAndDurationOfDataUsage;
